import React from 'react';

import style from './style.module.scss';

interface IProps {
  photoUrl: string | null;
  contactName: string;
  contactRole: string;
}

const TeamMemberCard = ({ photoUrl, contactName, contactRole }: IProps) => {
  return (
    <a href="mailto:support@waites.net" className={style.supportContact}>
      <img className={style.contactPhoto} src={photoUrl || ''} alt="contact-photo" />
      <div className={style.contactTitle}>
        <span className={style.contactNameWrapper}>
          <span className={style.contactName}>{contactName}</span>
          <span className={style.contactRole}>{contactRole}</span>
        </span>
      </div>
    </a>
  );
};

export default TeamMemberCard;
